import { createPaginatedKey } from "api/keys";

export const upholsteriesKeys = {
  upholsteriesEmployees: createPaginatedKey("upholsteriesEmployees"),
};
